import { FlowStepActionFunction } from '../flow-engine';
import { APIContextActions } from '../../api/APIContext';
import history from '../../routing/BrowserHistory';

export const action: FlowStepActionFunction = function (_apiActions: APIContextActions): void {
  history.replace(`/partner-error?error=${'not a prime member'}`);
};
